// @ngInject
function stateConfig($stateProvider) {

    $stateProvider.state('base.returnreasons.new', {
        url:'/new',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/returnreasons/returnreason/returnreason.tpl.html',
            controller: 'ReturnReasonController as vm'
        }},
        resolve: {
            returnreason: function() { return {}; },
            locations: locationsResolver,
            isNewReturnReason: function() {return true;}
        }
    });

    $stateProvider.state('base.returnreasons.returnreason', {
        url:'/{returnreasonId}',
        views: {
            'baseView@base': {
            templateUrl: 'main/base/returnreasons/returnreason/returnreason.tpl.html',
            controller: 'ReturnReasonController as vm'
        }},
        resolve: {
            returnreason: returnreasonResolver,
            locations: locationsResolver,
            isNewReturnReason: function() {return false;}
        }
    });

}

// @ngInject
function returnreasonResolver($stateParams, ReturnReasonsApiService) {
    return ReturnReasonsApiService.getReturnReason($stateParams.returnreasonId);
}

// @ngInject
function locationsResolver(ReturnReasonsApiService) {
    return ReturnReasonsApiService.getLocations();
}

// @ngInject
function ReturnReasonController($state, returnreason, loadSpinnerService, ReturnReasonsApiService, ToasterService, confirmationDialogService, $translate, isNewReturnReason, locations, $scope, FeatureSwitchService) {
    var vm = this;

    var returnreasonCopy = {};
    var locationCopy = {};

    vm.returnreason = returnreason;
    vm.locations = [];
    vm.location = {};
    vm.featureStockLocationEnabled = FeatureSwitchService.hasAdvancedReturnReason();

    vm.enableEditing = enableEditing;
    vm.cancelEditing = cancelEditing;
    vm.saveReturnReason = saveReturnReason;
    vm.deleteReturnReason = deleteReturnReason;

    vm.isNewReturnReason = isNewReturnReason;
    vm.isEditing = vm.isNewReturnReason;

    vm.isReturnReasonCodeValid = isReturnReasonCodeValid;
    vm.isAllInformationValid = isAllInformationValid;

    vm.toggleDisplayForm = toggleDisplayForm;

    activate();

    function activate() {
        vm.locations = locations.data;
        vm.locations.unshift(getNoLocationLocation());
        vm.location = vm.locations[0];
        _.forEach(vm.locations, function(location) { 
            if (vm.returnreason.stockLocationId && location.id === vm.returnreason.stockLocationId) {
                vm.location = location;
            }
         });
         

        prepareData();
        if (vm.isNewReturnReason) {
            vm.returnreason = {};
        }

        $scope.$watch(function() {
            return vm.location.id;
        }, 
        function(newValue, oldValue) {
            if (oldValue !== newValue) {
                vm.returnreason.stockLocationId = newValue;
            }
        });

        $scope.$watch(function() {
            return vm.returnreason.adjustStock;
        }, 
        function(newValue, oldValue) {
            if (newValue !== oldValue && !newValue) {
                vm.location = getNoLocationLocation();
            }
        });

    }

    function enableEditing() {
        returnreasonCopy = angular.copy(vm.returnreason);
        locationCopy = angular.copy(vm.location);
        vm.isEditing = true;
    }

    function cancelEditing() {
        vm.returnreason = returnreasonCopy;
        vm.location = locationCopy;
        vm.isEditing = false;
    }

    function saveReturnReason() {
        if (vm.isNewReturnReason) {
            saveNewReturnReason();
        } else {
            updateReturnReason();
        }
    }

    function saveNewReturnReason() {
        loadSpinnerService.start('mainSpinner');
        ReturnReasonsApiService.createReturnReason(vm.returnreason).then(function(response) {
            vm.returnreason = response;
            prepareData();
            vm.isNewReturnReason = false;
            vm.isEditing = false;
            $state.go('base.returnreasons.returnreason', {returnreasonId: vm.returnreason.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function updateReturnReason() {
        loadSpinnerService.start('mainSpinner');

        ReturnReasonsApiService.updateReturnReason(vm.returnreason).then(function(response) {
            vm.returnreason = response;
            prepareData();
            vm.isNewReturnReason = false;
            vm.isEditing = false;
            $state.go('base.returnreasons.returnreason', {returnreasonId: vm.returnreason.id});
        }, function(error) {
            console.log(error);
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).then(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function deleteReturnReason() {
        confirmationDialogService
            .showDialog($translate.instant('returnreason.confirmDelete'))
            .then(function(confirmation) {
                if (confirmation) {
                    loadSpinnerService.start('mainSpinner');
                    ReturnReasonsApiService.deleteReturnReason(vm.returnreason.id).then(function(response) {
                        vm.returnreason = response;
                        prepareData();
                        vm.isNewReturnReason = false;
                        vm.isEditing = false;
                        $state.go('base.returnreasons');
                    }, function(error) {
                        console.log(error);
                        ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
                    }).then(function() {
                        loadSpinnerService.stop('mainSpinner');
                    });
                }
            });
    }

    function toggleDisplayForm(returnreason) {
        returnreason.showEditForm = !returnreason.showEditForm;
    }

    function prepareData() {
        if (vm.returnreason === undefined) {
            return;
        }

        vm.returnreasonCopy = angular.copy(vm.returnreason);
    }

    function isAllInformationValid() {
        return isReturnReasonCodeValid();
    }

    function isReturnReasonCodeValid() {
        if (!vm.returnreason.code) { return false; }
        if (vm.returnreason.code.length > 20) { return false; }

        return true;
    }

    function getNoLocationLocation() {
        return { id: null, locationName: '---' };
    }

    function isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }

}

angular
    .module('returnreasons.returnreason', [])
    .config(stateConfig)
    .controller('ReturnReasonController', ReturnReasonController);
